import { createStore, applyMiddleware, compose } from 'redux';

import rootReducer from './root-reducer';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { rootSaga } from '../sagas/rootSagas';
import { routerMiddleware } from 'react-router-redux';

export const history = createBrowserHistory();

const composeEnhancers =
  (window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const sagaMiddleware = createSagaMiddleware();

function configureStore(initialState?: any) {
  const middlewares: any = [sagaMiddleware, routerMiddleware(history)];
  const enhancer = composeEnhancers(applyMiddleware(...middlewares));
  return createStore(rootReducer(history), initialState, enhancer);
}

// pass an optional param to rehydrate state on app start
const store = configureStore();
sagaMiddleware.run(rootSaga);

// export store singleton instance
export default store;
